module.exports = __webpack_public_path__ + "static/media/seqviz-brand-small.1b22f733.png";